import apiClient from './api-client'

function list() {
  return apiClient.get('roles')
}

export default {
  list,
}
